import { AsyncPaginate } from "react-select-async-paginate";
import { components } from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import createClass from "create-react-class";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: 500,
  },
}));

export default function AsyncReactSelectCheckboxes(props) {
  const {
    classNamePrefix,
    id = "",
    isMulti = true,
    loadOptions,
    onChange,
    placeholder = "Select",
    showCheckboxes = true,
    value,
  } = props;
  const classes = useStyles();
  const Option = createClass({
    render() {
      return (
        <div>
          <components.Option {...this.props}>
            {showCheckboxes ? (
              <input
                type="checkbox"
                checked={this.props.isSelected}
                onChange={(e) => null}
              />
            ) : null}{" "}
            <label className={classes.label}>{this.props.label} </label>
          </components.Option>
        </div>
      );
    },
  });

  return (
    // Taken from https://codesandbox.io/s/o567zv6j2q?file=/example.js:1576-1589
    <AsyncPaginate
      id={id}
      backspaceRemovesValue={false}
      classNamePrefix={classNamePrefix}
      closeMenuOnSelect={false}
      components={{ Option, MultiValue }}
      debounceTimeout={750}
      defaultOptions
      hideSelectedOptions={false}
      isClearable
      isMulti={isMulti}
      isSearchable
      loadOptions={loadOptions}
      menuPortalTarget={document.querySelector("main")}
      menuPosition={"fixed"}
      onChange={(e) => {
        onChange(e);
      }}
      placeholder={placeholder}
      styles={{
        menuPortal: (styles) => ({ ...styles, zIndex: 99999 }),
      }}
      value={value}
    />
  );
}

const MultiValue = (props) => {
  return (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );
};
